import { useMutation, useQuery } from "@tanstack/react-query";
import { TermsService, TermsFindAllPayload } from "../services/terms.service";
import {
  TermCreatePayload,
  TermUpdatePayload,
} from "../domain/terms.interface";

export const useTerms = (filters: TermsFindAllPayload) => {
  const {
    data: terms,
    isLoading: isLoadingTerms,
    isFetching: isFetchingTerms,
    refetch: refetchTerms,
  } = useQuery({
    queryKey: ["parca-terms-list"],
    queryFn: () => TermsService.findAll(filters),
  });

  return {
    terms,
    isLoadingTerms,
    isFetchingTerms,
    refetchTerms,
  };
};

export const useActiveTerm = (enabled = true) => {
  const {
    data: activeTerm,
    isLoading: isLoadingActiveTerm,
    refetch: refetchActiveTerm,
  } = useQuery({
    queryKey: ["parca-terms-active"],
    queryFn: () => TermsService.findActive(),
    enabled,
  });

  return {
    activeTerm,
    isLoadingActiveTerm,
    refetchActiveTerm,
  };
};

export const useCreateTerm = () => {
  return useMutation({
    mutationFn: (payload: TermCreatePayload) => TermsService.createOne(payload),
  });
};

export const useUpdateTerm = () => {
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: TermUpdatePayload }) =>
      TermsService.updateOne({ id, payload }),
  });
};

export const useActivateTerm = () => {
  return useMutation({
    mutationFn: ({ id, updatedBy }: { id: string; updatedBy: string }) =>
      TermsService.activateOne({ id, updatedBy }),
  });
};

export const useArchiveTerm = () => {
  return useMutation({
    mutationFn: (id: string) => TermsService.archiveOne(id),
  });
};
